import React, { useState, useEffect } from 'react';

import { Form, Divider, Select, Button, Space, Typography } from 'antd';

import emiter, { EVENT_CARRENTAL_DIFF_PR_CAR_SEARCH } from '../../../../events';

import { getDiffCityList } from 'hooks/carRental/store';
import {DEFAULT_PAGE_INFO} from "../../../../consts";

interface PropsType {
  enums?: any;
}

const { Title } = Typography;

const SPDifCityRemoteReturnSearchForm: React.FC<PropsType> = (props) => {
  const { enums } = props;

  const searchButtonText = '搜索';
  const clearButtonText = '清空';
  const searchFormFields = {
    quchechengshi: {name: 'pickup_city_id', label: '取车城市', required: false, message: '取车城市错误!', placeholder: '取车城市'},
    huanchechengshi: {name: 'return_city_id', label: '还车城市', required: false, message: '还车城市错误!', placeholder: '还车城市'},
  };


  const [searchForm] = Form.useForm();

  const [cityList, setCityList] = useState([]);

  const onSearchFormReset = () => {
    searchForm.resetFields();
    emiter.emit(EVENT_CARRENTAL_DIFF_PR_CAR_SEARCH, {
      ...searchForm.getFieldsValue(),
      ...DEFAULT_PAGE_INFO
    });
  };

  const onSearchFormFinish = () => {
    emiter.emit(EVENT_CARRENTAL_DIFF_PR_CAR_SEARCH, {
      ...searchForm.getFieldsValue(),
      ...DEFAULT_PAGE_INFO
    });
  };

  useEffect(() => {
    loadCityList();
    // emiter.on(EVENT_TRAVEL_SEARCH_ORDER_FROM_SEARCH, onSearchFormFinish)
  }, [])

  const loadCityList = () => {
    getDiffCityList({}).then((res: any) => {
      const cityList = res?.data?.city_list || [];
      setCityList(cityList);
    });
  }

  const formItemStyle: React.CSSProperties = { marginRight: '20px', display: 'inline-block' };

  return (
    <>
      <Divider />
      <Title level={3}>跨城异店取/还车设置</Title>
      <Form form={searchForm} onFinish={onSearchFormFinish}>
        <Form.Item
          style={formItemStyle}
          name={searchFormFields?.quchechengshi.name}
          label={searchFormFields?.quchechengshi.label}
          rules={[
            {
              required: searchFormFields?.quchechengshi.required,
              message: searchFormFields?.quchechengshi.message,
            },
          ]}
        >
          <Select allowClear style={{ width: '250px' }}>
            {cityList.map((item: any) => (
              <Select.Option
                value={item.city_id}
                placeholder={searchFormFields?.quchechengshi.placeholder}
              >{item.city_name}</Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          style={formItemStyle}
          name={searchFormFields?.huanchechengshi.name}
          label={searchFormFields?.huanchechengshi.label}
          rules={[
            {
              required: searchFormFields?.huanchechengshi.required,
              message: searchFormFields?.huanchechengshi.message,
            },
          ]}
        >
          <Select allowClear style={{ width: '250px' }}>
            {cityList.map((item: any) => (
              <Select.Option
                value={item.city_id}
                placeholder={searchFormFields?.quchechengshi.placeholder}
              >{item.city_name}</Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Space size="small">
          <Button type="primary" onClick={onSearchFormFinish}>{searchButtonText}</Button>
          <Button onClick={onSearchFormReset}>{clearButtonText}</Button>
        </Space>
      </Form>
      </>
  );
};

export default SPDifCityRemoteReturnSearchForm;

